import axios from 'axios';


const apiClient = function (){
    let bearerToken = localStorage.getItem('bearerToken');
    return axios.create({
        baseURL: '',
        withCredentials: false,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: bearerToken
        }
    });
}

export function getApiClient() {
    return apiClient();
}
